<div
    class="navigation-container"
    [ngClass]="{
        'slide-down ': scrollingUp && !isNavPanelShown,
        'slide-up': (!scrollingUp && isNavPanelShown) || !scrollingUp
    }"
>
    <vision2-navigation></vision2-navigation>
</div>
<div class="navigation-spacer"></div>
<div class="content">
    <div #topContent>
        <router-outlet></router-outlet>
    </div>
    <vision2-footer></vision2-footer>
</div>
